module.exports = __webpack_public_path__ + "img/icon-warning-active.54fcbc59.svg";